"use client";

import { useState } from "react";
import { Contents } from '@/@types';
import Image from 'next/image';
import { getEmbedUrl } from "@/helpers/media/getEmbedUrl";
import ModalVideoMedia from "@/components/ui/Modals/ModalVideoMedia";

type ProductProps = {
    videos: Contents[]
};

export default function ProductTabDocuments({ videos }: ProductProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [titleVideo, setTitleVideo] = useState<string | null>(null);

    const openModalWithVideo = (titleVideo: string, url: string) => {
        const embedUrl = getEmbedUrl(url);
        setVideoUrl(embedUrl);
        setIsModalOpen(true);
        setTitleVideo(titleVideo);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setVideoUrl(null);
        setTitleVideo(null);
    };

    return (
        <div className="bg-light00 ">
            <div>
                <ul className="grid grid-cols-1 lg:grid-cols-2 text-sm text-dark02">
                    {videos && videos.length > 0 ? (
                        videos.map((video: Contents, index: number) => (
                            <li className="border-b flex justify-between items-center pl-4 pr-4 pt-2 pb-2 gap-4" key={index}>
                                <button
                                    onClick={() => openModalWithVideo(video.title, video.local || video.media_url || '')}
                                    className="flex items-center justify-between w-full text-left"
                                >
                                    <span className="font-medium">{video.title ?? ''}</span>
                                    <button className="p-2 bg-light01 rounded-md cursor-pointer">
                                        <Image src="/video.svg" alt="Descargar" width={20} height={20} className='w-4 h-4' />
                                    </button>
                                </button>
                            </li>
                        ))
                    ) : (
                        <li className="pl-4 pr-4 pt-2 pb-2 text-center font-bold">Sin información de videos</li>
                    )}
                </ul>
            </div>

            {/* Modal para mostrar el video */}
            <ModalVideoMedia isOpen={isModalOpen} onClose={closeModal} titleVideo={titleVideo} videoUrl={videoUrl} />
        </div >
    )
}
